

<table class="table" style="background-color:white;">

  <tr>
    <td style="background-color:#0f2b46;color:white;" colspan="2">KYC UPLOAD</td>
    <td style="text-align: right;background-color: #0f2b46;color: white;padding-right: 32px;"><mat-icon [mat-dialog-close]="false">close</mat-icon></td>
  </tr>
</table>
<div *ngIf="loadingspinner == true" class="spin"></div>
<fieldset [disabled]="loadingspinner == true" [ngClass]="{'disabled':loadingspinner == true}">

  <section>
    <div class="container-fluid">
      <div class="row">
        <div [movableObject]="isDraggable"></div>
        <div class="container" *ngIf="metamapbutton == true">

          <!--<metamap-button [appVerification]="{{isDraggable}}" [attr.clientid]="clientid"   [attr.flowid]="flowid">
          </metamap-button>-->
        </div>

        <div class="col-lg-12" *ngIf="metamapbutton == false">
          <div class="row">
            <div class="col-lg-12 col-md-6">
              <table class="table table-hover text-center  table-bordered">
                <tr>
                  <td class="col" style="color:white !important;" *ngIf="warning">
                    Warning
                  </td>
                  <td class="col" style="color:white !important;" *ngIf="kycRemarkStatus">
                    Admin Remarks
                  </td>
                </tr>
                <tr>
                  <td style="white-space: nowrap;" *ngIf="warning">
                    {{warning}}
                  </td>

                  <td style="white-space: nowrap;" *ngIf="kycRemarkStatus">
                    {{kycRemarkStatus}}
                  </td>
                </tr>

              </table>

            </div>

          </div>

          <form class="example-form" (ngSubmit)="upload()" [formGroup]="kycForm">
            <div class="row">
              <div class="col-lg-4 col-md-4">
                <p style="font-family: Rajdhani, sans-serif; color: #FFFFFF; background-color:#00224f;text-align:center;">
                  UPLOAD A SELFIE WITH AN ID
                </p>
                <label for="" class="font-weight-bold">
                  1.Take a Clear photo of the ID card Along with the selfie.<br />
                  Note :- The photo must be clear enough and show your face and IDs. Please upload the photo of the ID card.<br />

                </label>
                <div class="img-height" *ngIf="imgURLId">
                  <img class="w-100" [src]="imgURLId" />
                </div>

                <div id="" *ngIf="btn == 0 || (btn == 4 && kycTypeStatus1 == false)">
                  <div class="custom-file mt-2">
                    <input type="file" class="custom-file-input" id="customFile1" #file1
                           accept='image/*' (change)="preview(file1.files,1)">
                    <label class="custom-file-label" for="customFile1">Choose file</label>
                  </div>
                  <mat-error *ngIf="!idProofImage">
                    {{msg1}}
                  </mat-error>
                </div>
                <mat-form-field>
                  <mat-label>Select Country</mat-label>
                  <mat-select formControlName="countryid" matTooltip="Select Country" autocomplete="off" required>
                    <mat-form-field>
                      <input matInput [formControl]="CountryFilterCtrl" placeholder="Search Country" />
                    </mat-form-field>
                    <mat-option *ngFor="let d of filterCountry(); let i=index" [value]="d.id">
                      <img matSuffix [src]="d?.countryFlag" style="height: 20px;width: 20px;" />
                      {{d?.name}}({{d?.isdCode}})
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="submitted && f.countryid.errors">
                    Select Country
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Select ID Type</mat-label>
                  <mat-select formControlName="KycType" matTooltip="Select ID Type" autocomplete="off" required>
                    <mat-option *ngFor="let d of Idprooflist; let i=index" [value]="d.id">
                      {{d?.doc_Name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="submitted && f.KycType.errors">
                    Select ID Type
                  </mat-error>
                </mat-form-field>

                <mat-form-field>

                  <input type="text" matInput placeholder="ID Number" formControlName="KycNumber" minlength="5" maxlength="20"
                         required />
                  <mat-error *ngIf="submitted && f.KycNumber.errors">
                    Enter ID Number
                  </mat-error>
                </mat-form-field>
                <mat-form-field>
                  <input matInput placeholder="Expiry ID Date" Numberonly
                         [matDatepicker]="picker1" maxlength="10" [min]="currentDate"
                         formControlName="kycExpiry" required>
                  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>

                  <mat-datepicker #picker1></mat-datepicker>
                  <mat-error *ngIf="submitted && f.kycExpiry.errors">
                    Choose Expiry ID Date
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <input type="text" matInput placeholder="Address" formControlName="address" minlength="2" maxlength="100" required />
                  <mat-error *ngIf="submitted && f.address.errors">
                    Enter Address
                  </mat-error>
                </mat-form-field>
                <mat-form-field>
                  <input type="text" matInput placeholder="City" formControlName="city" minlength="2" maxlength="100" required />
                  <mat-error *ngIf="submitted && f.city.errors">
                    Enter City
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <input type="text" matInput placeholder="State" formControlName="state" minlength="3" maxlength="100" required />
                  <mat-error *ngIf="submitted && f.state.errors">
                    Enter State
                  </mat-error>
                </mat-form-field>

                <!--<mat-form-field *ngIf="signinusercountryIsdcode == '+1'">-->
                <mat-form-field>
                  <input type="text" matInput placeholder="Zip Code/Postal Code" formControlName="zipcode" minlength="2" maxlength="20" required />
                  <mat-error *ngIf="submitted && f.zipcode.errors">
                    Enter Zip Code/Postal Code
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <input matInput placeholder="Date Of Birth" Numberonly [matDatepicker]="picker2" maxlength="10" [max]="currentDate"
                         formControlName="USERDOB" required>
                  <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                  <mat-error *ngIf="submitted && f.USERDOB?.errors">
                    Enter Date Of Birth
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-select placeholder="Select Gender" formControlName="Gender" required>
                    <mat-option value="M">
                      Male
                    </mat-option>
                    <mat-option value="F">
                      Female
                    </mat-option>
                    <mat-option value="O">
                      Other
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="submitted && f.Gender?.errors">
                    Select Gender
                  </mat-error>
                </mat-form-field>

              </div>

              <div class="col-lg-4 col-md-4">
                <p style="font-family: Rajdhani, sans-serif; color: #FFFFFF; background-color:#00224f;text-align:center;">
                  UPLOAD PERMIT - WORK/RESIDENCE/STUDENT/Visit
                </p>


                <label for="" class="font-weight-bold"></label>
                <div class="img-height" *ngIf="imgURLPERMIT">
                  <img class="w-100" [src]="imgURLPERMIT" />
                </div>
                <!--<div class="custom-file mt-2">
                  <input type="file" class="custom-file-input" id="customFile5" #file5
                         accept='image/*' (change)="preview(file5.files,5)">
                  <label class="custom-file-label" for="customFile5">Choose file</label>
                </div>-->

                <table>
                  <tr>
                    <td>
                      <mat-form-field>
                        <input matInput placeholder="Permit Expiry Date" numberOnlyMY [matDatepicker]="picker5" maxlength="10" [min]="currentDate"
                               formControlName="kycExpiry5" required>
                        <mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
                        <mat-datepicker #picker5></mat-datepicker>
                        <!--<mat-error *ngIf="submitted && f.kycExpiry4.errors">
                          Enter Expiry Date
                        </mat-error>-->
                      </mat-form-field>
                    </td>
                  </tr>
                </table>
              </div>


            </div>
            <div *ngIf="btn == 0  || (btn == 4 && flag == true)" class="d-flex justify-content-center align-items-center pt-3">

              <button type="submit" mat-raised-button color="primary" class="login-btn">
                Save
              </button>

            </div>
          </form>
        </div>
      </div>
    </div>


  </section>
</fieldset>


<!--kyc old below version change to mati sdk above-->
<!--<fieldset [disabled]="loadingspinner == true" [ngClass]="{'disabled':loadingspinner == true}">

  <section>
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-12 col-md-6">
              <table class="table table-hover text-center  table-bordered">
                <tr>
                  <td class="col" style="color:white !important;" *ngIf="warning">
                    Warning
                  </td>
                  <td class="col" style="color:white !important;" *ngIf="kycRemarkStatus">
                    Admin Remarks
                  </td>
                </tr>
                <tr>
                  <td style="white-space: nowrap;" *ngIf="warning">
                    {{warning}}
                  </td>

                  <td style="white-space: nowrap;" *ngIf="kycRemarkStatus">
                    {{kycRemarkStatus}}
                  </td>
                </tr>

              </table>

            </div>

          </div>

          <form class="example-form" (ngSubmit)="upload()" [formGroup]="kycForm">
            <div class="row">
              <div class="col-lg-4 col-md-4">
                <p style="font-family: Rajdhani, sans-serif; color: #FFFFFF; background-color:#00224f;text-align:center;">
                  UPLOAD A SELFIE WITH AN ID
                </p>
                <label for="" class="font-weight-bold">
                  1.Take a Clear photo of the ID card Along with the selfie.<br />
                  Note :- The photo must be clear enough and show your face and IDs. Please upload the photo of the ID card.<br />

                </label>
                <div class="img-height" *ngIf="imgURLId">
                  <img class="w-100" [src]="imgURLId" />
                </div>

                <div id="" *ngIf="btn == 0 || (btn == 4 && kycTypeStatus1 == false)">
                  <div class="custom-file mt-2">
                    <input type="file" class="custom-file-input" id="customFile1" #file1
                           accept='image/*' (change)="preview(file1.files,1)">
                    <label class="custom-file-label" for="customFile1">Choose file</label>
                  </div>
                  <mat-error *ngIf="!idProofImage">
                    {{msg1}}
                  </mat-error>
                </div>
                <mat-form-field>
                  <mat-label>Select Country</mat-label>
                  <mat-select formControlName="countryid" matTooltip="Select Country" autocomplete="off" required>
                    <mat-form-field>
                      <input matInput [formControl]="CountryFilterCtrl" placeholder="Search Country" />
                    </mat-form-field>
                    <mat-option *ngFor="let d of filterCountry(); let i=index" [value]="d.id">
                      <img matSuffix [src]="d?.countryFlag" style="height: 20px;width: 20px;" />
                      {{d?.name}}({{d?.isdCode}})
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="submitted && f.countryid.errors">
                    Select Country
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Select ID Type</mat-label>
                  <mat-select formControlName="KycType" matTooltip="Select ID Type" autocomplete="off" required>
                    <mat-option *ngFor="let d of Idprooflist; let i=index" [value]="d.id">
                      {{d?.doc_Name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="submitted && f.KycType.errors">
                    Select ID Type
                  </mat-error>
                </mat-form-field>

                <mat-form-field>

                  <input type="text" matInput placeholder="ID Number" formControlName="KycNumber" minlength="5" maxlength="20"
                         required />
                  <mat-error *ngIf="submitted && f.KycNumber.errors">
                    Enter ID Number
                  </mat-error>
                </mat-form-field>
                <mat-form-field>
                  <input matInput placeholder="Expiry ID Date" Numberonly
                         [matDatepicker]="picker1" maxlength="10" [min]="currentDate"
                         formControlName="kycExpiry" required>
                  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>

                  <mat-datepicker #picker1></mat-datepicker>
                  <mat-error *ngIf="submitted && f.kycExpiry.errors">
                    Choose Expiry ID Date
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <input type="text" matInput placeholder="Address" formControlName="address" minlength="2" maxlength="100" required />
                  <mat-error *ngIf="submitted && f.address.errors">
                    Enter Address
                  </mat-error>
                </mat-form-field>
                <mat-form-field>
                  <input type="text" matInput placeholder="City" formControlName="city" minlength="2" maxlength="100" required />
                  <mat-error *ngIf="submitted && f.city.errors">
                    Enter City
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <input type="text" matInput placeholder="State" formControlName="state" minlength="3" maxlength="100" required />
                  <mat-error *ngIf="submitted && f.state.errors">
                    Enter State
                  </mat-error>
                </mat-form-field>-->
<!--<mat-form-field *ngIf="signinusercountryIsdcode == '+1'">-->
<!--<mat-form-field>
                  <input type="text" matInput placeholder="Zip Code/Postal Code" formControlName="zipcode" minlength="2" maxlength="20" required />
                  <mat-error *ngIf="submitted && f.zipcode.errors">
                    Enter Zip Code/Postal Code
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <input matInput placeholder="Date Of Birth" Numberonly [matDatepicker]="picker2" maxlength="10" [max]="currentDate"
                         formControlName="USERDOB" required>
                  <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                  <mat-error *ngIf="submitted && f.USERDOB?.errors">
                    Enter Date Of Birth
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-select placeholder="Select Gender" formControlName="Gender" required>
                    <mat-option value="M">
                      Male
                    </mat-option>
                    <mat-option value="F">
                      Female
                    </mat-option>
                    <mat-option value="O">
                      Other
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="submitted && f.Gender?.errors">
                    Select Gender
                  </mat-error>
                </mat-form-field>

              </div>

              <div class="col-lg-4 col-md-4">
                <p style="font-family: Rajdhani, sans-serif; color: #FFFFFF; background-color:#00224f;text-align:center;">
                  UPLOAD A DEBIT/CREDIT CARD
                </p>

                <label for="" class="font-weight-bold ">
                  2.Take a Clear photo of your Visa/Master card you want to use for transaction showing complete card details.
                </label>
                <div class="img-height" *ngIf="imgURLCard">
                  <img class="w-100" [src]="imgURLCard" />
                </div>

                <div id="" *ngIf="btn == 0 || (btn == 4 && kycTypeStatus2 == false)">
                  <div class="custom-file  mt-2">
                    <input type="file" class="custom-file-input" id="customFile" #file2 accept='image/*'
                           (change)="preview(file2.files,2)">
                    <label class="custom-file-label" for="customFile">Choose file</label>
                  </div>
                  <mat-error *ngIf="!cardImage">
                    {{msg2}}
                  </mat-error>
                </div>
                <mat-form-field>
                  <mat-label>Select Card Type</mat-label>
                  <mat-select formControlName="KycType1" matTooltip="Select Card Type" autocomplete="off" required>
                    <mat-option *ngFor="let d of Cardprooflist; let i=index" [value]="d.id">
                      {{d?.doc_Name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="submitted && f.KycType1.errors">
                    Select Card Type
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <input type="text" matInput placeholder="Enter Full Card Number" formControlName="CardNumber"
                         minlength="19" maxlength="19" (blur)="transform()" Numberonly
                         required />
                  <mat-error *ngIf="submitted && f.CardNumber.errors">
                    Enter Full Card Number
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <input matInput placeholder="Expiry Card Date" Numberonly
                         [matDatepicker]="picker3" maxlength="10" [min]="currentDate"
                         formControlName="kycExpiry1" required>
                  <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>

                  <mat-datepicker #picker3></mat-datepicker>
                  <mat-error *ngIf="submitted && f.kycExpiry1.errors">
                    Choose Expiry Card Date
                  </mat-error>
                </mat-form-field>

              </div>
              <div class="col-lg-4 col-md-4">
                <p style="font-family: Rajdhani, sans-serif; color: #FFFFFF; background-color:#00224f;text-align:center;">
                  UPLOAD FRONT PICTURE
                </p>

                <label for="" class="font-weight-bold">
                  3.Take a clear front and Back side picture of you government provided ID card.
                </label>
                <label> Note -> If your id not having anything on Back please take Front side picture again.</label>
                <label for="" class="font-weight-bold"></label>
                <div class="img-height" *ngIf="imgURLIdfnt">
                  <img class="w-100" [src]="imgURLIdfnt" />
                </div>


                <div id="" *ngIf="btn == 0 || (btn == 4 && kycTypeStatus3 == false)">
                  <div class="custom-file mt-2">
                    <input type="file" class="custom-file-input" id="customFile2" #file3
                           accept='image/*' (change)="preview(file3.files,3)">
                    <label class="custom-file-label" for="customFile2">Choose file</label>
                  </div>
                  <mat-error *ngIf="!IdCrDeImagefnt">
                    {{msg3}}
                  </mat-error>
                </div>
                &nbsp;
                <p style="font-family: Rajdhani, sans-serif; color: #FFFFFF; background-color:#00224f;text-align:center;">
                  UPLOAD BACK PICTURE
                </p>

                <div class="img-height" *ngIf="imgURLIdback">
                  <img class="w-100" [src]="imgURLIdback" />
                </div>
                <div id="" *ngIf="btn == 0 || (btn == 4 && kycTypeStatus4 == false)">
                  <div class="custom-file mt-2">
                    <input type="file" class="custom-file-input" id="customFile2" #file4
                           accept='image/*' (change)="preview(file4.files,4)">
                    <label class="custom-file-label" for="customFile2">Choose file</label>
                  </div>
                  <mat-error *ngIf="!IdCrDeImageBACK">
                    {{msg4}}
                  </mat-error>
                </div>
              </div>
            </div>
            <div *ngIf="btn == 0  || (btn == 4 && flag == true)" class="d-flex justify-content-center align-items-center pt-3">

              <button type="submit" mat-raised-button color="primary" class="login-btn">
                Save
              </button>

            </div>
          </form>
        </div>
      </div>
    </div>


  </section>
</fieldset>-->
